
import { FC, useCallback, useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";

import IconButton from 'botframework-webchat-component/lib/SendBox/IconButton';
import { useMergedOptions } from "../../selectors/useMergedOptions";

import * as bsIcons from 'react-icons/bs';
import * as faIcons from 'react-icons/fa';
import classNames from "classnames";
import useDruidLocalize from "../../hooks/useDruidLocalize";

export const DruidChangeSideSelector: FC = () => {
    const [druidWebChatState, druidWebChatDispatch, ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

    const { disabled, UI: { v2_switch_icon = "", headerFontSize } = {},
        styleOptions: { } = {}
    } = useMergedOptions();
    const druidLocalize = useDruidLocalize();

    const SwitchIcon = bsIcons[v2_switch_icon] || faIcons[v2_switch_icon];

    const handleSwitchButtonClick = useCallback((e) => {
        e.stopPropagation();

        druidWebChatDispatch({
            type: 'SET_SIDE',
            payload: druidWebChatState.side === 'left' ? 'right' : 'left'
        });
    }, [druidWebChatState.side, druidWebChatDispatch]);
    // !!!!! --- Stylings are defined in DruidHeader.tsx !!!!!!
    return (SwitchIcon && (<IconButton
        alt={druidLocalize("DRUID_SETTINGS_SWITCH_SIDE_BUTTON_ALT")}
        className={classNames('druid__webchat__header-button', 'druid__webchat__header-fadeIn', 'druid__webchat__header-switch')}
        disabled={disabled}
        onClick={handleSwitchButtonClick}
    >
        <SwitchIcon size={headerFontSize}></SwitchIcon>
    </IconButton>)
    )
}




